import React, { useState, useEffect } from "react";
import {
    TextField,
    Button,
    Box,
    FormGroup,
    FormHelperText,
    Alert,
    AlertColor,
    AlertPropsVariantOverrides,
} from "@mui/material";
import { Formik, Form } from "formik";
import axiosInstance from "../../../services/axios-instance";
import * as Yup from "yup";
import TableClients from "../../elements/TableClients";
import { Client } from "../../../interface/clientInterface";
import { OverridableStringUnion } from "@mui/types";
import axios from "axios";

const validationSchema = Yup.object({
    name: Yup.string().required("Client Name is required"),
});

const AdminClients: React.FC = () => {
    const [clients, setClients] = useState<Client[]>([]);
    const [alertMessage, setAlertMessage] = useState("");
    const [severity, setSeverity] = useState<AlertColor | undefined>("info");
    const [variant, setVariant] = useState<
        | OverridableStringUnion<
              "standard" | "filled" | "outlined",
              AlertPropsVariantOverrides
          >
        | undefined
    >("filled");

    useEffect(() => {
        fetchClients();
    }, []);

    const fetchClients = async () => {
        try {
            const response = await axiosInstance.get("/clients");
            setClients(response.data.data);
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };

    const addClient = async (values: Client, { resetForm }: any) => {
        try {
            const response = await axiosInstance.post("/clients", values);

            if (response.status === 200 || response.status === 201) {
                setSeverity("success");
                setVariant("filled");
                setAlertMessage("Client added successfully");
                resetForm();
                fetchClients();
            } else {
                setSeverity("error");
                setAlertMessage("Error adding client");
            }
        } catch (error) {
            if (axios.isAxiosError(error)) {
                setSeverity("error");
                setVariant("filled");
                setAlertMessage(error.response?.data.message);
            }
        }
    };

    return (
        <div>
            <Box maxWidth="500px" mx="auto">
                <h2 style={{ marginBottom: "0.5rem" }}>Add Client</h2>
                <Formik
                    initialValues={{ id: 0, name: "" }}
                    validationSchema={validationSchema}
                    onSubmit={addClient}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        touched,
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <FormGroup>
                                <TextField
                                    label="Client Name"
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    error={touched.name && Boolean(errors.name)}
                                />
                                {errors.name && touched.name && (
                                    <FormHelperText>
                                        {errors.name}
                                    </FormHelperText>
                                )}
                            </FormGroup>
                            <Box mt={2}>
                                <Button variant="contained" type="submit">
                                    Add Client
                                </Button>
                            </Box>
                        </Form>
                    )}
                </Formik>
                <Box sx={{ mt: "1rem" }}>
                    {alertMessage != "" && (
                        <Alert
                            onClick={() => setAlertMessage("")}
                            variant={variant}
                            severity={severity}
                        >
                            {alertMessage}
                        </Alert>
                    )}
                </Box>
            </Box>
            {clients.length === 0 ? (
                <Box marginTop={4}>
                    <p>No clients found.</p>
                </Box>
            ) : (
                <Box marginTop={4}>
                    <TableClients clients={clients} setClients={setClients} />
                </Box>
            )}
        </div>
    );
};

export default AdminClients;
